import { formatNumber } from 'utils/numberFormat';
import { HTMLAttributes, memo } from 'react';
import { useTranslate } from '@tolgee/react';
import { Detail, priceRender } from './TradeDetailPaymentLazada';

export interface TradeIncomeAmountProps extends HTMLAttributes<HTMLElement> {
  trade: Conversation.Trade.Vo;
  defaultFold?: boolean;
}

/** shopee 买家实付金额 */
function TradeDetailIncomeAliExpress(props: TradeIncomeAmountProps) {
  const { trade } = props;

  const { unit, tradeIncome } = trade;

  const { t } = useTranslate();

  return (
    <Detail>
      {priceRender(tradeIncome?.itemPrice, (val) => {
        return (
          <li>
            <dt>{t('商品金额')}</dt>
            <dd>{`${unit} ${formatNumber(val, '0,0.00')}`}</dd>
          </li>
        );
      })}
      {priceRender(tradeIncome?.shippingFee, (val) => {
        return (
          <li>
            <dt>{t('运费小计(实际)')}</dt>
            <dd>{`${unit} ${formatNumber(val, '0,0.00')}`}</dd>
          </li>
        );
      })}

      {priceRender(tradeIncome?.vat, (val) => {
        return (
          <li>
            <dt>{t('trade_label_income_vat')}</dt>
            <dd>{`${unit} ${formatNumber(val, '0,0.00')}`}</dd>
          </li>
        );
      })}

      {priceRender(tradeIncome?.orderAmount, (val) => {
        return (
          <li>
            <dt>{t('translation.订单金额')}</dt>
            <dd>{`${unit} ${formatNumber(val, '0,0.00')}`}</dd>
          </li>
        );
      })}

      {priceRender(tradeIncome?.escrowAmount, (val) => {
        return (
          <li>
            <dt>{t('trade.订单收入')}</dt>
            <dd>{`${unit} ${formatNumber(val, '0,0.00')}`}</dd>
          </li>
        );
      })}
    </Detail>
  );
}

export default memo(TradeDetailIncomeAliExpress);
